import {ContainerMain} from './'
/**
  * Bug #491
  * @Author Jithin Kuriakose
  * @Date 09 July 2021
  */
import PropType from 'prop-types';

const propTypes = {
  
     /**
     * Defines the center container
     * @defaultValue true
     */
      centerOnly: PropType.bool, 
    
};
  
const defaultProps = {
    centerOnly: false,
};

export default function Container({children, centerOnly}) {
    return (
        <>
        {
            centerOnly 
            ?
                <ContainerMain style={{marginTop:'5px'}}>
                        {children}
                </ContainerMain>
            :
                <ContainerMain fluid style={{marginTop:'5px'}}>
                        {children}
                </ContainerMain>
        }
        </>
    )
}
Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
/** End Bug #491**/